// extracted by mini-css-extract-plugin
export default {"dropzone":"dropzone_dropzone__dK4x7","error":"dropzone_error__2Yon4","icon":"dropzone_icon__65j4l"};